import React from 'react';
import {Modal, ModalHeader, ModalTitle, ModalClose, ModalBody, ModalFooter} from 'react-modal-bootstrap';
import {Field, reduxForm} from "redux-form";
import SubmitButton from "../common/SubmitButton";
import {injectIntl} from "react-intl";
import {ChangePasswordFormValidator} from './ChangePasswordFormValidator';
import {UserInput} from './UserInput';

class ChangeUserPasswordModal extends React.Component
{
    constructor(props) {
        super(props);
    }

    render() {
        return (
           <Modal className="contact-person-modal" isOpen={this.props.isOpen}>
               <form noValidate={true} onSubmit={this.props.handleSubmit}>
                   <ModalHeader className="contact-person-modal">
                       <ModalTitle>Skift kodeord</ModalTitle>
                       <ModalClose onClick={this.props.closeModal} />
                   </ModalHeader>

                   <ModalBody>

                       <div className="form-group row">
                           <label className="col-sm-2 col-form-label">
                               <b>Nuværende kodeord</b>
                           </label>
                           <div className="col-sm-10">
                               <Field
                                   type="password"
                                   name="oldPassword"
                                   component={UserInput}
                                   className="form-control"
                               />
                           </div>
                       </div>

                       <div className="form-group row">
                           <label className="col-sm-2 col-form-label">
                               <b>Nyt kodeord</b>
                           </label>
                           <div className="col-sm-10">
                               <Field
                                   type="password"
                                   name="newPassword"
                                   component={UserInput}
                                   className="form-control"
                               />
                           </div>
                       </div>

                       <div className="form-group row">
                           <label className="col-sm-2 col-form-label">
                               <b>Gentag nyt kodeord</b>
                           </label>
                           <div className="col-sm-10">
                               <Field
                                   type="password"
                                   name="confirmNewPassword"
                                   component={UserInput}
                                   className="form-control"
                               />
                           </div>
                       </div>
                   </ModalBody>
                   <ModalFooter>
                       <SubmitButton isUpdate={true}/>
                   </ModalFooter>
               </form>
           </Modal>
        );
    }
}

ChangeUserPasswordModal = reduxForm({
    form: 'changeUserPasswordModalForm',
    validate: ChangePasswordFormValidator
})(ChangeUserPasswordModal);

ChangeUserPasswordModal = injectIntl(ChangeUserPasswordModal);

export default ChangeUserPasswordModal;


// WEBPACK FOOTER //
// ./web/src/components/users/ChangeUserPasswordModal.jsx